module.exports = __webpack_public_path__ + "img/lp.27a82759.jpg";